import reviewPhotoMelodie from '../social-proof/assets/melodie.png';
import reviewPhotoRosa from '../social-proof/assets/rosadlpe.png';
import reviewPhotoAceofspades from '../social-proof/assets/aceofspades.png';
import reviewPhotoKnobodi from '../social-proof/assets/knobodi.png';
import reviewPhotoTess from '../social-proof/assets/tess.png';
import reviewPhotoStephanie from '../social-proof/assets/stephanie.png';
import reviewPhotoBilly from '../social-proof/assets/billy.png';
import reviewPhotoOhwllfine from '../social-proof/assets/ohwllfine.png';

export type SocialProofReview = {
  title: string;
  author: string;
  text: string;
  photo: string;
};

/**
 * The same eight App Store reviews the /social-proof interstitial carried, in its order.
 *
 * All eight rather than a hand-picked few: the strip auto-scrolls, so depth costs no screen
 * space, and a longer loop is less repetitive for anyone who lingers. Keeping the original
 * set also means the two surfaces make the same claims with the same wording.
 *
 * These are real reviewer handles and photos. Consent/licensing for them is an open blocker
 * on card I36 (I50 flagged the same question for the Nyx onboarding photo wall); they are
 * already live in production on /social-proof.
 */
export const SOCIAL_PROOF_REVIEWS: SocialProofReview[] = [
  {
    title: 'Game Changer',
    author: 'Melodie L.',
    text: "I've tried so many different ways to get my sleep schedule consistent...this app has been a genuine life changer.",
    photo: reviewPhotoMelodie,
  },
  {
    title: 'What a Difference',
    author: 'rosadlpe',
    text: "I'd sleep 5h on weekdays then 12+ on the weekend. I'm now sleeping consistently & waking earlier on weekends. I have more energy & feel way better.",
    photo: reviewPhotoRosa,
  },
  {
    title: 'Sleep debt is a real thing',
    author: 'Aceofspades141',
    text: "Before using rise I didn't know sleep debt had such an impact on my day to day life but I've gotten it down from 22 hours to 4 and now I feel much better.",
    photo: reviewPhotoAceofspades,
  },
  {
    title: 'Yes please',
    author: "knobodi's Beez-niss",
    text: "This app knows me. I'm very confident in what it has to say about my sleep pattern and how I should be sleeping.",
    photo: reviewPhotoKnobodi,
  },
  {
    title: "One of the best things I've done",
    author: '07Tess_Tickle07',
    text: 'Rise has revolutionized my sleeping patterns. Sleep has always been a challenge for me...I now regularly keep my sleep debt under 5 hours.',
    photo: reviewPhotoTess,
  },
  {
    title: 'Life changing',
    author: 'StephanieSasson',
    text: 'This is an incredible tool! I use it every day and it has great features and things you will learn about yourself, highly recommend!',
    photo: reviewPhotoStephanie,
  },
  {
    title: 'Life gets brighter with Rise',
    author: 'billy3578',
    text: 'The sleep science here is top notch. With the time tracking with smart alarm is really working for me.',
    photo: reviewPhotoBilly,
  },
  {
    title: 'Effective',
    author: 'ohwllfine',
    text: 'I am very happy with this app. Knowing the time my natural melatonin is high has worked miracles in getting me to sleep better.',
    photo: reviewPhotoOhwllfine,
  },
];
